import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface BillingPortalButtonProps {
  shopId?: string;
}

export const BillingPortalButton = ({ shopId }: BillingPortalButtonProps) => {
  const [loading, setLoading] = useState(false);

  const handleOpenPortal = async () => {
    if (!shopId) {
      toast.error('Shop ID not found');
      return;
    }

    setLoading(true);

    try {
      const { data, error } = await supabase.functions.invoke('stripe-create-portal', {
        body: {
          shop_id: shopId,
          return_url: `${window.location.origin}/shop-profile?tab=billing`,
        },
      });

      if (error) throw error;

      if (data?.url) {
        window.open(data.url, '_blank');
      }
    } catch (error: any) {
      console.error('Portal error:', error);
      toast.error(error.message || 'Failed to open billing portal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button onClick={handleOpenPortal} disabled={loading} variant="outline" data-testid="open-billing-portal-btn">
      <ExternalLink className="h-4 w-4 mr-2" />
      {loading ? 'Opening...' : 'Manage in Stripe'}
    </Button>
  );
};
